import { Suspense } from 'react';

import { Route, Switch } from 'react-router-dom';

import { Snack } from 'components/Snack';
import { settings } from 'config';
import { SnackProvider, UserProvider } from 'contexts';
import { ContentWrapper as AuditorDashboard } from 'layout/auditor_dashboard/ContentWrapper';
import { ContentWrapper as CandidateAdminDashboard } from 'layout/candidate_admin_dashboard/ContentWrapper';
import { ContentWrapper as EmployerDashboard } from 'layout/candidate_dashboard/ContentWrapper';
import { ContentWrapper as Front } from 'layout/front/ContentWrapper';
import { ContentWrapper as SignerDashboard } from 'layout/signer_dashboard/ContentWrapper';
import { ContentWrapper as SystemAdminDashboard } from 'layout/system_admin_dashboard/ContentWrapper';

import { ClassificationBanner } from '../components/ClassificationBanner';
import { MaintenanceBanner } from '../components/MaintenanceBanner';

export const App = () => {
  const {
    MAINTENANCE_BANNER_SHOW,
    MAINTENANCE_BANNER_BACKGROUND_COLOR,
    MAINTENANCE_BANNER_TEXT_COLOR,
    MAINTENANCE_BANNER_TEXT,
  } = settings.maintenance_banner;
  return (
    <SnackProvider>
      <Snack />
      <UserProvider>
        <Suspense fallback={<div />}>
          <ClassificationBanner color='green' text='CUI' />
          {MAINTENANCE_BANNER_SHOW === 'true' && (
            <MaintenanceBanner
              backgroundColor={MAINTENANCE_BANNER_BACKGROUND_COLOR}
              textColor={MAINTENANCE_BANNER_TEXT_COLOR}
              text={MAINTENANCE_BANNER_TEXT?.toUpperCase()}
            />
          )}
          <Switch>
            <Route
              path='/home/candidate_admin_dashboard/'
              component={CandidateAdminDashboard}
            />
            <Route
              path='/home/employer_dashboard/'
              component={EmployerDashboard}
            />
            <Route path='/home/signer_dashboard/' component={SignerDashboard} />
            <Route
              path='/home/auditor_dashboard/'
              component={AuditorDashboard}
            />
            <Route
              path='/home/system_admin_dashboard/'
              component={SystemAdminDashboard}
            />
            <Route path='/home' component={Front} />
          </Switch>
          <ClassificationBanner color='green' text='CUI' />
        </Suspense>
      </UserProvider>
    </SnackProvider>
  );
};
